import LatestStories from "./LatestStories";
import AdBanner from "./AdBanner";

const RightSidebar = () => {
  return (
    <aside className="lg:col-span-3">
      <div className="sticky top-[120px] space-y-4">
        
        {/* 🔹 LATEST STORIES */}
        <LatestStories />

        {/* 🔹 ADVERTISEMENT */}
        <AdBanner />

      </div>
    </aside>
  );
};

export default RightSidebar;
